import { render, staticRenderFns } from "./UserDropdownItem.vue?vue&type=template&id=1d6eda49&functional=true&"
import script from "./UserDropdownItem.vue?vue&type=script&lang=js&"
export * from "./UserDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdownItem.vue?vue&type=style&index=0&id=1d6eda49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports